module.exports = __webpack_public_path__ + "img/amk_mobile.6a7cd3a1.png";